module.exports = __webpack_public_path__ + "static/media/orange.8b686606.svg";